
import { defineComponent } from 'vue';
import globalConstants from '@/shared/globalConstants';
import FbxButton from '@/components/fbx-button.vue';
import { isNullOrUndefined } from '@/shared/helpers';
const { knight, swift } = globalConstants.companies;

export default defineComponent({
    name: 'ReturnOptions',
    components: {
        FbxButton,
    },
    props: {
        inModal: Boolean,
        company: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    computed: {
        returnApp(): string {
            const routeCompany = this.$route?.params?.company;

            if (this.company === knight || routeCompany === knight) {
                return 'KT Mobile';
            } else if (this.company === swift || routeCompany === swift) {
                return 'Pointe';
            } else {
                return '';
            }
        },
    },
    methods: {
        routeToDashboard(): void {
            window.location.href = 'eleos://dashboard';
        },
    },
});
